/**
 * API configuration for Portfolio Tracker frontend.
 *
 * Loads API base URL from environment variables.
 */

const API_URL = process.env.EXPO_PUBLIC_API_URL || 'https://topnote-api-sbp5f6nlfa-uc.a.run.app';

// Debug mode - set to true to enable console logging for troubleshooting
export const DEBUG = process.env.EXPO_PUBLIC_DEBUG === 'true' || __DEV__;

export const API_CONFIG = {
  baseURL: API_URL,
  timeout: 30000, // 30 seconds
  headers: {
    'Content-Type': 'application/json',
  },
};

export const API_ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    REGISTER: '/auth/register',
    LOGIN: '/auth/login',
    VERIFY: '/auth/verify',
  },
  // Portfolio endpoints
  PORTFOLIO: {
    UPLOAD: '/portfolio/upload',
    POSITIONS: '/portfolio/positions',
    TRADES: '/portfolio/trades',
  },
  // Comment endpoints
  COMMENTS: {
    CREATE: '/comments',
    GET: '/comments/:tradeId',
    UPDATE: '/comments/:commentId',
    DELETE: '/comments/:commentId',
  },
} as const;
